export default function Loader() {
    return (
        <div id="loader">
            <div className="dottet-loader" />
            <p className="mt-2">Loading...</p>
        </div>
    );
}
